<template>
  <div class="col-sm mg-t-10 mg-sm-t-0">
    <div class="bg6 rounded-20 pos-relative" role="button">
      <h5 class="t-15 l-15 pos-absolute tx-white">Хандалт</h5>
      <div class="d-flex ht-250 wd-100p align-items-center justify-content-center">
        <ul class="list-group wd-100p tx-white">
          <li
            class="list-group-item d-flex align-items-center pd-y-2 bd-0"
            style="background: transparent"
          >
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">Видео үзсэн</h6>
            <div
              class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1"
              style="background: rgba(0, 0, 0, 0.2)"
            >
              {{ Number(statObj.videoViewedCount).toLocaleString() }}
            </div>
          </li>
          <li
            class="list-group-item d-flex align-items-center pd-y-2 bd-0"
            style="background: transparent"
          >
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">
              Дасгал ажилсан
            </h6>
            <div
              class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1"
              style="background: rgba(0, 0, 0, 0.2)"
            >
            {{ Number(statObj.dasgalAjillasanCount).toLocaleString() }}
            </div>
          </li>
          <li
            class="list-group-item d-flex align-items-center pd-y-2 bd-0"
            style="background: transparent"
          >
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">
              Уншсан материал
            </h6>
            <div
              class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1"
              style="background: rgba(0, 0, 0, 0.2)"
            >
            {{ Number(statObj.readContentViewedCount).toLocaleString() }}
            </div>
          </li>
          <li
            class="list-group-item d-flex align-items-center pd-y-2 bd-0"
            style="background: transparent"
          >
            <feather type="circle" style="height: 20px"></feather>
            <h6 class="mg-l-5 mg-t-4 tx-semibold tx-12 tx-white mg-b-0">Курс хандалт</h6>
            <div
              class="mg-l-auto rounded tx-semibold tx-11 pd-x-6 pd-y-1"
              style="background: rgba(0, 0, 0, 0.2)"
            >
            {{ Number(statObj.courseViewedCount).toLocaleString() }}
            </div>
          </li>
        </ul>
      </div>
      <div
        class="pos-absolute d-flex l-15 b-15 tx-11 tx-white wd-100p pd-r-25 align-items-center justify-content-center"
      >
        <div>
          <div
            @click="swChanged()"
            role="switch"
            :class="`el-switch ${filterObj.mode == 1 ? 'is-checked' : ''}`"
          >
            <span class="el-switch__core" style="width: 30px"></span>
            <span class="el-switch__label el-switch__label--right mg-l-5 tx-white">
              <span aria-hidden="true">{{
                filterObj.mode == 1 ? "Миний" : "Нийтийн"
              }}</span>
            </span>
          </div>
        </div>
        <div class="mg-l-auto" role="button" @click="dateMdl= true">2023.01.01 - 2023.08.01</div>
      </div>
    </div>

    <b-modal v-model="dateMdl" hide-footer title="Шүүх">
      <form>
        <div class="form-group">
          <label class="d-block">Эхлэх</label>
        <VueCtkDateTimePicker
                          locale="mn"
                          v-model="filterObj.start"
                          no-label
                          format="YYYY-MM-DD"
                        />
        </div>
        <div class="form-group">
          <label class="d-block">Дуусах</label>
        <VueCtkDateTimePicker
                          locale="mn"
                          v-model="filterObj.end"
                          no-label
                          format="YYYY-MM-DD"
                        />
        </div>
        
        <div class="btn-group">
          <a @click="init();" class="btn btn-primary">Шүүх</a>
          <a @click="dateMdl=false" class="btn btn-secondary">Хаах</a>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import { request } from "@/api/all";

const moment = require("moment");

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      dateMdl: false,
      filterObj: {
        mode: 1,
        start: null,
        end: null,
      },
      statObj: {
        courseViewedCount: 0,
        dasgalAjillasanCount: 0,
        readContentViewedCount: 0,
        videoViewedCount: 0,
      },
    };
  },
  mounted() {
    this.filterObj.start = moment().startOf("year").format("yyyy.MM.DD");
    this.filterObj.end = moment().format("yyyy.MM.DD");

    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    swChanged() {
      this.filterObj.mode = this.filterObj.mode == 1 ? 0 : 1;
      this.init();
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "v2/Learn/GetHomeContentViewedCount" },
        params: this.filterObj,
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.statObj = res.data;
          this.dateMdl= false;
        }
      });
    },
  },
};
</script>
